import { ManuteRequestConfig } from '@/api/types';
import { RequestQueryParams } from '@/api/requests/types';

const BASE_URL = '/permissions';

/**
 * Request to find all permissions.
 * @param params
 */
export const ALL = (params?: RequestQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: BASE_URL,
    params: {
        ...params,
    },
});

/**
 * Request to fetch list of logged user permissions.
 */
export const ALL_LOGGED_USER = (): ManuteRequestConfig => ({
    method: 'GET',
    url: `/users/me/permissions`,
});
